const KNOWN_EVENT_LABEL_KEYS: Record<string, string> = {
  page_view: 'websiteActivity.events.pageView',
  register_start: 'websiteActivity.events.registerStart',
  register_success: 'websiteActivity.events.registerSuccess',
  free_trial_start: 'websiteActivity.events.freeTrialStart',
  free_trial_success: 'websiteActivity.events.freeTrialSuccess',
  free_trial_failed: 'websiteActivity.events.freeTrialFailed',
  plan_selected: 'websiteActivity.events.planSelected',
  payment_started: 'websiteActivity.events.paymentStarted',
  payment_success: 'websiteActivity.events.paymentSuccess',
};

export function isKnownWebsiteEvent(eventType: string): boolean {
  return eventType in KNOWN_EVENT_LABEL_KEYS;
}

export function websiteEventLabelKey(eventType: string): string {
  return KNOWN_EVENT_LABEL_KEYS[eventType]!;
}
